import * as types from "../types";
import axios from "axios";

axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.token;

const state = {};
const getters = {};
const mutations = {};

const actions = {
  [types.GET_NOTIF_LIST]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .get(types.API_BASE_URL + "notif/push/list", payload)
        .then(response => {
          if (response.data.status == 200) {
            resolve(response.data.data);
          } else {
            reject(response.data.messages);
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            commit(types.MUTATE_LOGOUT);
            reject(error.message);
          } else {
            reject(error.message);
          }
        });
    });
  },

  [types.CREATE_NOTIF]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .post(types.API_BASE_URL + "notif/push/create", payload)
        .then(response => {
          if (response.data.status == 200) {
            resolve(response.data.data);
          } else {
            reject(response.data.messages);
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            commit(types.MUTATE_LOGOUT);
            reject(error.message);
          } else {
            reject(error.message);
          }
        });
    });
  },

  [types.SEND_NOTIF]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .post(types.API_BASE_URL + "notif/push/send", payload)
        .then(response => {
          if (response.data.status == 200) {
            resolve(response.data.data);
          } else {
            reject(response.data.messages);
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            commit(types.MUTATE_LOGOUT);
            reject(error.message);
          } else {
            reject(error.message);
          }
        });
    });
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
